import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-otro-interes',
  templateUrl: './otro-interes.component.html',
  styleUrls: ['./otro-interes.component.css']
})
export class OtroInteresComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    $('#arriba-g').click(
      function()
          {
                $('html,body').animate({scrollTop:'0px'}, 500);
                return false;
          }
    );
    $('#arriba-a').click(
      function()
          {
                $('html,body').animate({scrollTop:'0px'}, 500);
                return false;
          }
    );
    // let node = document.createElement('script');
    // node.src = "assets/js/animacion.js";
    // node.type = 'text/javascript';
    // document.getElementsByTagName('head')[0].appendChild(node);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/shared/otro-interes/otro-interes.component.ts